import V2ForgotPasswordScene from './ForgotPasswordScene'
export default V2ForgotPasswordScene